"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCoreDataDictionarySlice = void 0;
exports.buildUpdateForField = buildUpdateForField;
exports.buildUpdateForObject = buildUpdateForObject;
const xuder_1 = require("@sonar-software/xuder");
const sonar_ts_types_1 = require("@sonar-software/sonar-ts-types");
const actions_1 = require("../sonar-objects/_idMap/actions.js");
const _types_1 = require("../../@types/index.js");
const _api_1 = require("../../api/index.js");
function buildBaseUpdate(entry) {
    return {
        context: {
            definition: entry.definition,
            notes: entry.notes
        },
        ingestedBy: entry.ingestedBy,
        populatedBy: entry.populatedBy,
        salesforce: {
            description: entry.description,
            managedPackage: entry.managedPackage
        },
        sonarObjectId: entry.sonarObjectId,
        stakeholders: entry.stakeholderIds,
        users: entry.ownerIds.map((ownerId) => ({
            responsibilityType: _types_1.ResponsibilityType.Owner,
            userId: ownerId
        }))
    };
}
function buildUpdateForField(field) {
    const base = buildBaseUpdate(field);
    return Object.assign(Object.assign({}, base), { salesforce: Object.assign(Object.assign({}, base.salesforce), { complianceCategory: field.complianceCategory || undefined, dataSensitivityLevelId: field.dataSensitivityLevelId, fieldUsageId: field.fieldUsageId, helpText: field.helpText, isCustom: field.custom }), sonarObjectType: sonar_ts_types_1.SonarObjectType.SalesforceField, tags: field.tagIds ? field.tagIds : undefined });
}
function buildUpdateForObject(object, objectType) {
    const base = buildBaseUpdate(object);
    return Object.assign(Object.assign({}, base), { salesforce: Object.assign(Object.assign({}, base.salesforce), { isCustom: object.isCustom }), sonarObjectType: objectType });
}
exports.getCoreDataDictionarySlice = (0, xuder_1.createGetAsyncSlice)({
    httpSagaOptions: {
        successCombinationActionCreators: [
            (request, response) => {
                const objectType = request.sonarObjectType;
                const context = response.results.map((result) => (objectType && objectType.toLowerCase() !== sonar_ts_types_1.SonarObjectType.SalesforceField.toLowerCase() ?
                    buildUpdateForObject(result, objectType) :
                    buildUpdateForField(result)));
                return (0, actions_1.updateSonarObjectReferences)(context);
            }
        ]
    },
    name: 'CoreDataDictionary',
    receive: true,
    request: true,
    requestHandler: _api_1.getDataDictionary,
    retainDataOnRequest: true
});
//# sourceMappingURL=get.js.map